import {
  getStepPosition,
  useComparateurStore,
  type FunnelStep,
} from './useComparateurStore';

interface StepEyebrowProps {
  step: FunnelStep;
  /** Surcharge le texte. Utile pour une étape optionnelle (« Étape rapide »). */
  override?: string;
}

/**
 * Eyebrow dynamique « Étape X sur Y » qui s'adapte au dossier courant
 * (l'étape Usages disparaît si aucun profil sectoriel ne matche).
 */
export function StepEyebrow({ step, override }: StepEyebrowProps) {
  const dossier = useComparateurStore((s) => s.dossier);
  const { current, total } = getStepPosition(step, dossier);
  const label = override ?? `Étape ${current} sur ${total}`;
  return (
    <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-stone-400">
      {label}
    </p>
  );
}
